import { useContainer } from '@hub-la/fe-container'
import { HttpClient } from '@hub-la/fe-core-http-client'
import { useMutation } from '@tanstack/react-query'
import { SaveMembersAreaSettingsRequest } from '../../../../domain/dtos/member-area/settings/save-members-area'
import { SaveMembersArea } from '../../../../usecases/member-area/settings/save-members-area'

export const useSaveMembersArea = () => {
  const container = useContainer()

  const { isSuccess, isError, error, isLoading, data, mutateAsync } = useMutation(
    [],
    (values: SaveMembersAreaSettingsRequest) => {
      return new SaveMembersArea(container.get(HttpClient)).execute(values)
    },
  )

  return {
    isSuccess,
    isError,
    error,
    isLoading,
    data,
    mutateAsync,
  }
}
